import React from 'react'
import DataLabAccounts from './DataLabAccounts'

const ShowLabAccounts:React.FC = () => {

  return (
    <div className='mt-3'>
      <DataLabAccounts />
    </div>
  )
}

export default ShowLabAccounts
